import { gql } from "@apollo/client";

export const GET_PROJECTS_BY_COMPANY = gql`
  query GetProjectsByCompany($refName: String!) {
    mdmProjectsByCompany(companyReference: $refName) {
      id
      title
    }
  }
`;

export const GET_PROJECT = gql`
  query GetProject($id: String!) {
    mdmProjectById(id: $id) {
      companyReference
      id
      title
      datasetMode
      filterInfo {
      allFields {
        containerType, fieldType, key, label, inputType, leaf,
        enum {
          key, label
        }
      }
      allOperators {
        key, label
      }
    }
      deviceConfigs {
        id
        title
        vitalityThreshold
        measurementMappings {
          key
          value
        }
      }
      configuration {
        analyticsConfiguration {
          dataTypes {
            name
          }
          resultTypes {
            type
          }
        }
        objectConfiguration {
          customFields {
            id
            parent
            title
            type
          }
        }
        deviceConfiguration {
          customFields {
            id
            parent
            title
            type
          }
          measurementTypes {
            id
            title
          }
        }
      }
    }
  }
`;

export const CREATE_PROJECT = gql`
  mutation CreateProject($project: MdmProjectInputInput!) {
    createMdmProject(input: $project) {
      id
      title
      companyReference
      datasetMode
      configuration {
        analyticsConfiguration {
          dataTypes {
            name
          }
          resultTypes {
            type
          }
        }
        objectConfiguration {
          customFields {
            id
            parent
            title
            type
          }
        }
        deviceConfiguration {
          customFields {
            id
            parent
            title
            type
          }
          measurementTypes {
            id
            title
          }
        }
      }
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation UpdateProject($project: MdmProjectDTOInput!) {
    updateMdmProject(input: $project) {
      companyReference
      id
      title
      datasetMode
      deviceConfigs {
        id
        title
        vitalityThreshold
        measurementMappings {
          key
          value
        }
      }
      configuration {
        analyticsConfiguration {
          dataTypes {
            name
          }
          resultTypes {
            type
          }
        }
        objectConfiguration {
          customFields {
            id
            parent
            title
            type
          }
        }
        deviceConfiguration {
          customFields {
            id
            parent
            title
            type
          }
          measurementTypes {
            id
            title
          }
        }
      }
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation DeleteProject($id: String!) {
    deleteMdmProject(id: $id) {
      id
      title
    }
  }
`;

export const CREATE_UPDATE_DEVICE_CONFIGURATION = gql`
  mutation CreateUpdateDeviceConfiguration($input: MdmDeviceConfigDTOInput!) {
    createUpdateDeviceConfig(input: $input) {
      id
      title
      measurementMappings {
        key
        value
      }
      vitalityThreshold
    }
  }
`;

export const DELETE_DEVICE_CONFIGURATION = gql`
  mutation DeleteDeviceConfiguration($id: String!) {
    deleteDeviceConfig(configId: $id) {
      id
    }
  }
`;
